import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "font-semibold my-0 text-center" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = {
  key: 0,
  class: "text-red"
}
const _hoisted_4 = { class: "form-field-split active rounded-20 mt-5 my-6" }
const _hoisted_5 = { class: "form-field-floating full lg w-40" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-field-floating lg reactive w-60" }
const _hoisted_8 = {
  key: 1,
  class: "text-red"
}
const _hoisted_9 = {
  key: 2,
  class: "text-red"
}
const _hoisted_10 = {
  key: 3,
  class: "text-red"
}
const _hoisted_11 = {
  key: 4,
  class: "text-red"
}
const _hoisted_12 = {
  key: 5,
  class: "text-red"
}

import { onMounted, reactive, ref } from "vue";
    import OnboardingUploadInput from "./components/OnboardingUploadInput.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingIdentityDocumentsForm',
  props: {
        user: { type: Object, required: true },
        types_piece_identites: { type: Object, required: true },
        hideHeader: { type: Boolean, default: false }
    },
  emits: ['saved'],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        photo: null as any,
        type_piece_identite: "1",
        numero_piece_identite: '',
        piece_recto: null as any,
        piece_verso: null as any,
    });
    const errors = reactive({
        photo: '',
        piece_recto: '',
        piece_verso: '',
        type_piece_identite: '',
        numero_piece_identite: '',
    });

    function validate() {
        let isValid = true;

        errors.piece_recto = '';
        if (!formData.piece_recto) {
            errors.piece_recto ="La pièce recto est requise";
            isValid = false;
        }

        errors.piece_verso = '';
        if (!formData.piece_verso) {
            errors.piece_verso ="La pièce verso est requise";
            isValid = false;
        }

        errors.type_piece_identite = '';
        if (!formData.type_piece_identite) {
            errors.type_piece_identite ="Le type de pièce d'identité est requis";
            isValid = false;
        }

        errors.numero_piece_identite = '';
        if (!formData.numero_piece_identite) {
            errors.numero_piece_identite ="Le numéro de pièce d'identité est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFileUploaded(field: 'photo' | 'piece_recto' | 'piece_verso', uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData[field] = { file: uploadedFile.file, name: uploadedFile.file_name, preview: uploadedFile.file_preview };
    }

    async function onSubmit() {
        if (!validate()) { return; }
        emit('saved', formData);
        /**/
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!props.hideHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(props.user.nom + ' ' + props.user.prenom), 1),
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "font-normal text-center mt-3 mb-7" }, "Identifiez-vous", -1))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("form", _hoisted_2, [
      _createVNode(OnboardingUploadInput, {
        id: "photo",
        label: "Photo de profil",
        onUploaded: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded('photo', $event)))
      }),
      (!!errors['photo'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(errors['photo']), 1))
        : _createCommentVNode("", true),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "h-10" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "type_piece_identite",
            id: "type_piece_identite",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.type_piece_identite) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.types_piece_identites, (value, key, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: key,
                key: 'type_piece_' + index
              }, _toDisplayString(value), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.type_piece_identite]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "type_piece_identite" }, [
            _createTextVNode("Pièce d'identité "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "numero_piece_identite",
            id: "numero_piece_identite",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.numero_piece_identite) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.numero_piece_identite]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("label", { for: "numero_piece_identite" }, [
            _createTextVNode("N° de pièce d'identité "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (!!errors['type_piece_identite'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['type_piece_identite']), 1))
        : _createCommentVNode("", true),
      (!!errors['numero_piece_identite'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors['numero_piece_identite']), 1))
        : _createCommentVNode("", true),
      _createVNode(OnboardingUploadInput, {
        id: "file-upload-recto",
        label: "Pièce recto",
        onUploaded: _cache[3] || (_cache[3] = ($event: any) => (onFileUploaded('piece_recto', $event))),
        required: ""
      }),
      (!!errors['piece_recto'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors['piece_recto']), 1))
        : _createCommentVNode("", true),
      _createVNode(OnboardingUploadInput, {
        id: "file-upload-verso",
        label: "Pièce verso",
        onUploaded: _cache[4] || (_cache[4] = ($event: any) => (onFileUploaded('piece_verso', $event))),
        required: ""
      }),
      (!!errors['piece_verso'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['piece_verso']), 1))
        : _createCommentVNode("", true),
      (!!errorMessage.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-read text-grey-600 text-center mt-6" }, " Format de fichier supporté: PDF, JPG, PNG, GIF. Taille max: 5MB. ", -1)),
      _createElementVNode("button", {
        id: "btn-save-identity-documents",
        type: "button",
        class: "btn lg w-100 flex-center mt-5",
        onClick: onSubmit
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("img", {
          src: "/icons/icon-valider.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Valider", -1)
      ]))])
    ])
  ]))
}
}

})